interface SubCategoryAttributes {
	readonly id: string;
	readonly name: string;
	readonly description: string;
	readonly value: number;
	readonly owas_category_id: string;
}

export class SubCategory {
	public readonly id: string;
	public readonly name: string;
	public readonly description: string;
	public readonly value: number;
	public readonly owas_category_id: string;

	constructor({ id, name, value, description, owas_category_id }: SubCategoryAttributes) {
		this.id = id;
		this.name = name;
		this.description = description;
		this.value = value;
		this.owas_category_id = owas_category_id;
	}
}
